import type { IconProps } from './types';

export const CalendarIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={1.5}
            {...props}
        >
            <path
                d="M19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5Z"
                stroke="currentColor"
            />
            <path d="M6.30615 5V3" stroke="currentColor" />
            <path d="M17.7891 5V3" stroke="currentColor" />
            <path
                d="M9.61215 8.41113H7.30615C6.75387 8.41113 6.30615 8.85885 6.30615 9.41113V11.7171C6.30615 12.2694 6.75387 12.7171 7.30615 12.7171H9.61215C10.1644 12.7171 10.6122 12.2694 10.6122 11.7171V9.41113C10.6122 8.85885 10.1644 8.41113 9.61215 8.41113Z"
                fill="currentColor"
            />
        </svg>
    );
};
